import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, EMPTY, BehaviorSubject } from 'rxjs'; import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service'; import { AuthHeaderService } from 'src/app/services/auth-header.service';
import { retry, catchError, filter } from 'rxjs/operators'; import { from } from 'rxjs'; import { TotpService } from 'src/app/services/totp.service';
import { Asset } from 'src/app/models/liveshop'; import { IStoreData } from '../@types/Store';
import { ResponseData, AssetsResponse } from 'src/app/models/liveshop'; import { switchMap } from 'rxjs/operators';
import { formatDate } from '@angular/common'; import { SanctumService } from 'src/app/services/sanctum.service';
import { setting } from 'src/app/models/listSettings';
import { Ga4MetricsResponse } from 'src/app/models/ga4_metrics';
import { environment } from 'src/environments/environment';
import { RevalidatedHttpService, RevalidatedResource } from 'src/app/core/http-cache/revalidated-http.service';
interface slicksStats {
  likeCount: number;
  espectadores: number;
  watched: number;
  content: number;
}
export interface Session {
  session_id: string;
}

export interface GranularData {
  date: string;
  views: number;
  viewers: {
    mobile: number;
    desktop: number;
  };
  avg_views_per_viewer: number;
  avg_slicks_per_viewer: number;
  avg_watched_time: number;
  likes: number;
  clicks: number;
}
export interface Viewers {
  mobile: number;
  desktop: number;
}
export interface OverviewData {
  views: number;
  viewers: Viewers; // Alterado para refletir o novo formato
  avg_views_per_viewer: number;
  avg_slicks_per_viewer: number;
  avg_watched_time: number;
  likes: number;
  clicks: number;
}

export interface PlayerAnalytics {
  overview_data: OverviewData;
  granular_data: GranularData[];
}

export interface AnalyticsResponse {
  player_analytics: PlayerAnalytics;
}
interface Produto {
  id: number;
  item_group_id: number;
  name: string;
  stock_qty: number;
  track_inventory: number;
  status: number;
  min_qty: number;
  inputQty: number;
  price: string;
  onsale_price: string;
  price_exchange: string;
  thumbnail: string;
  qtd: number;
  isSelected?: boolean;
  highlight?: boolean;
  define_interval?: boolean;
  showSlider?: boolean;
  comprarFontColor?: string;
  comprarBgColor?: string;
  adicionarFontColor?: string;
  adicionarBgColor?: string;
  interval_time?: { start: string; end: string };

}

interface UpdateAssetResponse {
  widget: {
    assets: {
      items: {
        content: {
          cta: {
            components: {
              custom: any[];
              products: {
                items: any[];
              };
              links: any[];
            };
          };
        };
      }[];
    };
  }[];
}
interface SlickMaps {
  id: number;
  uniq_id: string;
  asset_uniq_id: string;
  url: string;
  status: number;
  created_at: string;
  updated_at: string;
  type: number;
}
export interface SlickAnalytics {
  asset_id: string;
  name: string;
  video_url: string;
  views: number;
  viewers: number;
  avg_views_per_viewer: number;
  avg_slicks_per_viewer: number;
  avg_watched_time: number;
  likes: number;
  clicks: number;
}

export interface TopSlicks {
  top_slicks: SlickAnalytics[];
}
export interface NewSlicks {
  assets: AssetList[];
  totalAssets: number;
}
export interface AssetList {
  items: Item[];
}
export interface Item {
  schedule: Schedule;
  media: Media;
  content: Content;
}
export interface Schedule {
  date_from: string;
  date_to: string | null;
}

export interface Media {
  type: string;
  src: string;
  thumbnail: string | null;
  duration: number;
  stream_status: string;
  aspect_ratio: string;
  pin: number;
  status: number;
}

export interface Content {
  id: number;
  uid: string;
  title: string;
  description: string;
  cta: any[];
}
@Injectable({
  providedIn: 'root'
})
export class LiveShopService {

  dadosUsuario: any
  loja_id: any
  lojasUsuario: any
  baseurl = `${environment.apiBaseUrl}/api`; // Base_url
  baseurl2 = `${environment.apiBaseUrl}/`; // Base_url

  constructor(
    private httpClient: HttpClient,
    private totpService: TotpService,
    private http: HttpClient,
    private authHeaderService: AuthHeaderService,
    private auth: AuthService,
    private sanctum: SanctumService,
    private revalidatedHttp: RevalidatedHttpService) {

    // this.dadosUsuarioLogado();
    if (environment.production) {
      this.baseurl = environment.serverUrl;
    } else {
      this.baseurl = environment.paymentGenetatorLinkURL;
    }
  }


  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.getAccessToken()}`
    }),
  };

  // Error handling


  getAccessToken(): string {
    return localStorage.getItem("access_token") || '';
  }

  getUser(): any {
    return JSON.parse(localStorage.getItem("user") || '');
  }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // Ocorreu um erro do lado do cliente ou da rede.
      console.error('Um erro ocorreu:', error.error.message);
    } else {
      // Ocorreu um erro do lado do servidor.
      console.error(
        `Código do erro ${error.status}, ` +
        `Erro: ${error.error}`);
    }
    // Retornar uma mensagem de erro para o usuário.
    return throwError(
      'Alguma coisa deu errado; tente novamente mais tarde.');
  };

  async getLiveViewers(liveShopId: string): Promise<Observable<any>> {
    const protocol = window.location.protocol === 'https:' ? 'https://' : 'http://';
    const url = `${protocol}slicksell.click:1438/get-user-count/${liveShopId}`;

    const httpOptions = await this.totpService.getChatHttpOptions();
    return this.http.get<any>(url, httpOptions);
  }

  payLive(liveShopId: string): Observable<any> {
    const url = `${this.baseurl2}/liveshopping/pay/${liveShopId}`;

    if (environment.production) {
      return this.http.patch<any>(url, null, this.httpOptions);
    } else {
      return this.http.patch<any>(url, null, this.httpOptions);
    }
  }


  private isRequestMade = false;

  getStorneInfos(subdomain: string): Observable<any> {
    const body = { subdomain };
    console.log('chamou 4');
    const url = `${environment.apiBaseUrl}/api/admin/store`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<any>(url, body, httpOptions)
          )
        )
      ),
      retry(1),
      catchError(this.handleError)
    );
  }


  async getChatMessages(liveShopId: string): Promise<Observable<any>> {
    const protocol = window.location.protocol === 'https:' ? 'https://' : 'http://';
    const url = `${protocol}slicksell.click:1438/all_messages/${liveShopId}`;

    const httpOptions = await this.totpService.getChatHttpOptions();
    return this.http.get<any>(url, httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }


  getAssets(): Observable<AssetsResponse> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<AssetsResponse>(url, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  // Cache-first com ETag.
  getAssetsRevalidated(): RevalidatedResource<AssetsResponse> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset`;
    const cacheKey = `assets:store:${id_loja}`;

    return this.revalidatedHttp.getSignal<AssetsResponse>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }


  private analyticsCache = new Map<string, BehaviorSubject<AnalyticsResponse | null>>();

  getAnalyticsCached(dateFrom: string, dateTo: string, slickId?: string, forceRefresh = false): Observable<AnalyticsResponse> {
    const cacheKey = `${dateFrom}_${dateTo}_${slickId || ''}`;

    if (!this.analyticsCache.has(cacheKey) || forceRefresh) {
      const subject = new BehaviorSubject<AnalyticsResponse | null>(null);

      this.getAnalytics(dateFrom, dateTo, slickId).subscribe({
        next: (res) => subject.next(res),
        error: (err) => {
          subject.error(err);
          this.analyticsCache.delete(cacheKey); // evita cache com erro
        }
      });

      this.analyticsCache.set(cacheKey, subject);
    }

    return this.analyticsCache.get(cacheKey)!.pipe(
      filter((res): res is AnalyticsResponse => res !== null)
    );
  }

  getAnalytics(dateFrom: string, dateTo: string, slick_id?: string): Observable<AnalyticsResponse> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    let url = `${baseUrl}/store/${id_loja}/analytics/overview?date_from=${dateFrom}&date_to=${dateTo}`;
    if (slick_id) {
      url += `&slick_id=${slick_id}`;
    }

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<AnalyticsResponse>(url, httpOptions)
      ),
      catchError(error => throwError(error))
    );
  }

  // Mesmo padrão cache-first do getTopSlicksRevalidated — mostra o overview
  // salvo na hora e revalida em segundo plano via If-None-Match.
  getAnalyticsRevalidated(dateFrom: string, dateTo: string, slick_id?: string): RevalidatedResource<AnalyticsResponse> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    let url = `${baseUrl}/store/${id_loja}/analytics/overview?date_from=${dateFrom}&date_to=${dateTo}`;
    if (slick_id) {
      url += `&slick_id=${slick_id}`;
    }

    const cacheKey = `overview:store:${id_loja}:from:${dateFrom}:to:${dateTo}:slick:${slick_id || ''}`;

    return this.revalidatedHttp.getSignal<AnalyticsResponse>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  getTopSlicks(dateFrom: string, dateTo: string): Observable<TopSlicks> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const url = `${environment.apiBaseUrl}/api/store/${id_loja}/analytics/top_slicks?score=views&limit=6&page=0&date_from=${dateFrom}&date_to=${dateTo}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap((httpOptions) =>
        this.http.get<TopSlicks>(url, httpOptions)
      ),
      catchError(error => throwError(error))
    );
  }

  // Piloto do cache-first com ETag (ver src/app/core/http-cache) — mostra o
  // último resultado salvo na hora (sessionStorage/memória) e revalida em
  // segundo plano com If-None-Match. Mantido junto de getTopSlicks() (não
  // substitui) até validar o padrão antes de migrar as outras rotas do dashboard.
  getTopSlicksRevalidated(dateFrom: string, dateTo: string): RevalidatedResource<TopSlicks> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const url = `${environment.apiBaseUrl}/api/store/${id_loja}/analytics/top_slicks?score=views&limit=6&page=0&date_from=${dateFrom}&date_to=${dateTo}`;

    const cacheKey = `top_slicks:store:${id_loja}:from:${dateFrom}:to:${dateTo}`;

    return this.revalidatedHttp.getSignal<TopSlicks>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  // Mesmo padrão cache-first do getTopSlicksRevalidated/getAnalyticsRevalidated.
  getNewSlicksRevalidated(dateFrom: string, dateTo: string): RevalidatedResource<NewSlicks> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const formattedDateFrom = formatDate(dateFrom, 'dd/MM/yyyy', 'en');
    const formattedDateTo = formatDate(dateTo, 'dd/MM/yyyy', 'en');

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset?date_from=${formattedDateFrom}&date_to=${formattedDateTo}`;

    const cacheKey = `asset:store:${id_loja}:from:${formattedDateFrom}:to:${formattedDateTo}`;

    return this.revalidatedHttp.getSignal<NewSlicks>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  getNewSlicks(dateFrom: string, dateTo: string): Observable<NewSlicks> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const formattedDateFrom = formatDate(dateFrom, 'dd/MM/yyyy', 'en');
    const formattedDateTo = formatDate(dateTo, 'dd/MM/yyyy', 'en');

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset?date_from=${formattedDateFrom}&date_to=${formattedDateTo}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<NewSlicks>(url, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  getNewSlicks1(): Observable<NewSlicks> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<NewSlicks>(url, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  getAssetsPublic(limit: number | null, type: string, page: number, seed: number, slickId?: string | null): Observable<AssetsResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || 163;
    let appendLink = '';
    if (slickId) {
      appendLink = '&slick_id=' + slickId;
      if (slickId == '1') {
        appendLink = '&l=1&slick_id=' + slickId;
      }
    }
    let limitAssets = '';
    if (limit != null) {
      limitAssets = `&limit=${limit}`;
    }



    return this.http
      .get<AssetsResponse>(`${environment.apiBaseUrl}/api/public/admin/store/${id_loja}/videoshopping/asset_public?type=${type}${limitAssets}&page=${page}${appendLink}&random=1&seed=${seed}`, httpOptions)
      .pipe(catchError(error => throwError(error)));
  }

  getAssetsFromWidgetsPublic(
    widget_id: number,
    limit: number | null,
    type: string,
    page: number,
    slickId?: string | null
  ): Observable<AssetsResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`,
        'X-Full-Referer': window.location.href
      }),
    };

    const id_loja = localStorage.getItem("ss_SelectedStoreId") || 163;
    let appendLink = '';
    if (slickId) {
      appendLink = '&slick_id=' + slickId;
      if (slickId == '1') {
        appendLink = '&l=1&slick_id=' + slickId;
      }
    }
    let limitAssets = '';
    if (limit != null) {
      limitAssets = `&limit=${limit}`;
    }

    const baseUrl = `${environment.apiBaseUrl}/api/admin/store/${id_loja}/videoshopping/widget/${widget_id}/assets?type=${type}${limitAssets}&page=${page}${appendLink}`;

    return this.http
      .get<AssetsResponse>(baseUrl, httpOptions)
      .pipe(catchError(error => throwError(error)));
  }


  listarAssetsWidgetPublic(widget_id: number | undefined, page: number = 1, limit: number | null = 10): Observable<IStoreData> {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`,
        'X-Full-Referer': window.location.href,
        'X-Mobile-App': 'true',
      }),
    };
    let id_loja = 163;
    const storeJson = localStorage.getItem('store');
    if (storeJson) {
      try {
        const storeObj = JSON.parse(storeJson);
        if (storeObj.SelectedStoreId) {
          id_loja = storeObj.SelectedStoreId;
        }
      } catch (e: any) {
        console.warn('não foi possível parsear o store no localStorage', e);
      }
    }
    if (limit == null) limit = 9;

    return this.httpClient.get<IStoreData>(`${environment.apiBaseUrl}/api/public/admin/store/${id_loja}/videoshopping/widget/${widget_id}/assets_public?page=${page}&limit=${limit}`, this.httpOptions);
  }


  createDeviceData(data: any): Observable<Session> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '163';

    return this.http
      .post<Session>(`${environment.apiBaseUrl}/api/public/store/${id_loja}/session`, data, httpOptions)
      .pipe(catchError(error => throwError(error)));
  }

  createPlayerEvent(
    sessionId: string,
    playerSessionId: string,
    assetUid: string,
    payload: { event: string; details?: any; add_to_cart?: any }
  ): Observable<any> {
    const storeId = this.resolveStoreId();
    if (!storeId) {
      return throwError(() => new Error('Store ID not found'));
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      })
    };

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/public/store/${storeId}/videoshopping/events/session/${sessionId}/player_session/${playerSessionId}/asset/${assetUid}`;

    return this.http
      .post(url, payload, httpOptions)
      .pipe(catchError(error => throwError(() => error)));
  }

  gerarSessaoVisitante(data: any): Observable<any> {
    const storeId = this.resolveStoreId() || localStorage.getItem("ss_SelectedStoreId") || '163';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`,
        'X-Full-Referer': window.location.href,
      }),
    };

    return this.http
      .post<any>(`${environment.apiBaseUrl}/api/public/store/${storeId}/guest_auth`,
        JSON.stringify(data),
        httpOptions
      )
      .pipe(catchError(error => throwError(error)));

  }


  pinarSlick(data: any, uid: string): Observable<ResponseData> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/${uid}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<ResponseData>(url, data, httpOptions)
          )
        )
      ),
      catchError(error => throwError(() => error))
    );
  }


  sendUids(uids: string[], n: number, date_from?: string, date_to?: string): Observable<slicksStats> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    let query = `type=${n}`;
    if (date_from && date_to) {
      query += `&date_from=${date_from}&date_to=${date_to}`;
    }

    const url = `${baseUrl}/admin/store/${id_loja}/slicksStats?${query}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<slicksStats>(url, JSON.stringify(uids), httpOptions)
          )
        )
      ),
      catchError(error => throwError(() => error))
    );
  }


  getFilteredAssetsByDate(
    date_from: string,
    date_to: string
  ): Observable<{ assets: Asset[]; totalAssets: number }> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset?date_from=${date_from}&date_to=${date_to}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<{ assets: Asset[]; totalAssets: number }>(url, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  // Cache-first com ETag.
  getFilteredAssetsByDateRevalidated(
    date_from: string,
    date_to: string
  ): RevalidatedResource<{ assets: Asset[]; totalAssets: number }> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset?date_from=${date_from}&date_to=${date_to}`;
    const cacheKey = `assets:store:${id_loja}:from:${date_from}:to:${date_to}`;

    return this.revalidatedHttp.getSignal<{ assets: Asset[]; totalAssets: number }>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }

  // Filtro de "Status do Slick" (publicado/agendado/naoPublicado) aplicado no
  // backend em vez de localmente — o endpoint tem limit padrão de 500 e o
  // filtro local só enxerga o que já foi carregado, então loja com muitos
  // slicks não-publicados fazia o filtro "Publicado" não achar nada mesmo
  // havendo itens de verdade (bug real, 2026-10-15).
  getAssetsByStatusRevalidated(status: string): RevalidatedResource<{ assets: Asset[]; totalAssets: number }> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset?status=${encodeURIComponent(status)}`;
    const cacheKey = `assets:store:${id_loja}:status:${status}`;

    return this.revalidatedHttp.getSignal<{ assets: Asset[]; totalAssets: number }>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }



  DeleteSlick(id: any): Observable<Asset> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset/${id}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(httpOptions =>
        this.http.delete<Asset>(url, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }


  postarComentario(
    mediaId: string,
    message: string,
    feed_uid: string,
    content_uid: string,
    fbid: string,
    instagram_account_id: string,
    owner?: string,
    sender_handle?: string,
    sender_avatar?: string
  ): Observable<any> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const body: any = {
      message,
      feed_uid,
      content_uid,
      fbid,
      instagram_account_id
    };
    if (owner) body.owner = owner;
    if (sender_handle) body.sender_handle = sender_handle;
    if (sender_avatar) body.sender_avatar = sender_avatar;

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/feed/${mediaId}/comment`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.post<any>(url, body, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }


  excluirComentario(
    commentId: string,
    content_uid: string,
    fbid: string
  ): Observable<any> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/feed/comment/${commentId}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.delete<any>(url, { ...httpOptions, body: { content_uid, fbid } })
      ),
      catchError(error => throwError(() => error))
    );
  }


  getSentCommentsLive(contentUid: string): Observable<{
    comments: {
      comment_id: string;
      text: string | null;
      replies: { id: string; text: string; timestamp: string; from?: { id: string; username: string } }[];
    }[]
  }> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${id_loja}/feed/${contentUid}/comments_live`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions => this.http.get<any>(url, httpOptions)),
      catchError(error => throwError(() => error))
    );
  }


  saveUrKeyWord(contentUid: string, urKeyWord: string, commentValue?: string): Observable<any> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${id_loja}/liveshopping/uniq_id/${contentUid}/ur_key_word`;
    const body: any = { ur_key_word: urKeyWord };
    if (commentValue) body.comment_value = commentValue;
    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.patch<any>(url, body, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  saveChapters(contentUid: string, chapters: { title: string; time: string }[]): Observable<any> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/admin/store/${id_loja}/liveshopping/uniq_id/${contentUid}/chapters`;
    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.patch<any>(url, { chapters }, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  getInstagramPermalink(mediaId: string, accessToken: string): Observable<string> {
    const url = `https://graph.facebook.com/v19.0/${mediaId}?fields=permalink&access_token=${accessToken}`;
    return this.http.get<{ permalink: string }>(url).pipe(
      map(res => res.permalink)
    );
  }


  postToExternalEndpoint(folder: string, objectName: string): Observable<any> {
    const url = 'https://hkdk.events/zbx8fq9566t9rd';
    const body = { folder: folder, object_name: objectName };

    return this.http.post(url, body, this.httpOptions)
      .pipe(catchError(error => throwError(error)));
  }
  saveSlick(data: any): Observable<ResponseData> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(httpOptions =>
        this.http.post<ResponseData>(url, data, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  detailSettings(): Observable<setting[]> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/settings`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<setting[]>(url, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  // Cache-first com ETag.
  detailSettingsRevalidated(): RevalidatedResource<setting[]> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/settings`;
    const cacheKey = `settings:store:${id_loja}`;

    return this.revalidatedHttp.getSignal<setting[]>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }


  detailAsset(uid: string): Observable<Asset> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset/${uid}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<Asset>(url, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  // Cache-first com ETag — só pra leitura/exibição (ex: abrir sidebar de
  // produto). NÃO usar antes de um fluxo de escrita que precisa do dado mais
  // fresco possível (ex: "duplicar como template" em lives.component).
  detailAssetRevalidated(uid: string): RevalidatedResource<Asset> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset/${uid}`;
    const cacheKey = `asset_detail:store:${id_loja}:uid:${uid}`;

    return this.revalidatedHttp.getSignal<Asset>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }


  // Captura um frame do vídeo direto no backend (via ffmpeg) — server-to-
  // server, sem restrição de CORS (funciona pra qualquer origem: CloudFront
  // próprio, Instagram, TikTok etc.). Devolve o JPEG puro; quem sobe pro S3
  // continua sendo o frontend (mesmo fluxo do modo "Upload de imagem").
  captureVideoThumbnailFrame(src: string, time: number): Observable<Blob> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset/capture_thumbnail`;

    console.log('[LiveShopService] captureVideoThumbnailFrame: start', { url, src, time });

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.post(url, { src, time }, { ...httpOptions, responseType: 'blob' as const })
      ),
      catchError(error => {
        console.error('[LiveShopService] captureVideoThumbnailFrame: erro', error);
        return throwError(() => error);
      })
    );
  }


  updateAsset(data: any, asset_id: number): Observable<UpdateAssetResponse> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset/${asset_id}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(httpOptions =>
        this.http.patch<UpdateAssetResponse>(url, data, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  // Endpoint dedicado só pra produtos (LiveShopController::updateAssetProducts)
  // — não mexe em mais nada do slick (media, chapters, alertas, links...),
  // ao contrário de updateAsset() que exige o payload completo.
  updateAssetProducts(uid: string, products: any[]): Observable<{ message: string; code?: string; uid?: string }> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset/${uid}/products`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(httpOptions =>
        this.http.patch<{ message: string; code?: string; uid?: string }>(url, { products }, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }


  createSlickMaps(data: any): Observable<Produto> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/maps`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(httpOptions =>
        this.http.post<Produto>(url, data, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }



  clearSlickMaps(uniq_id: string): Observable<SlickMaps> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset/${uniq_id}/maps`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(httpOptions =>
        this.http.delete<SlickMaps>(url, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }


  getUserMediaByHandle(
    handle: string,
    source_id: string,
    page: number = 1,
    limit: number = 20
  ): Observable<{ assets: any[]; totalAssets: number; page: number; limit: number; nextPage?: number }> {
    const id_loja = localStorage.getItem('ss_SelectedStoreId') || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset`;

    // Query params
    const params: any = {
      handle,
      source_id,
      page: String(page),
      limit: String(limit)
    };

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(httpOptions => {
        const options = { ...httpOptions, params };
        return this.http.get<{ assets: any[]; totalAssets: number; page: number; limit: number; nextPage?: number }>(url, options);
      }),
      catchError(err => throwError(() => err))
    );
  }


  getUserMediaByHandlePublic(
    handle: string,
    source_id: string,
    page: number = 1,
    limit: number = 20
  ): Observable<{ assets: any[]; totalAssets: number; page: number; limit: number; nextPage?: number }> {
    const id_loja = localStorage.getItem('ss_SelectedStoreId') || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset`;

    // Query params
    const params: any = {
      handle,
      source_id,
      page: String(page),
      limit: String(limit)
    };

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(httpOptions => {
        const options = { ...httpOptions, params };
        return this.http.get<{ assets: any[]; totalAssets: number; page: number; limit: number; nextPage?: number }>(url, options);
      }),
      catchError(err => throwError(() => err))
    );
  }

  getUserMediaByHandlePublicStore(
    handle: string,
    source_id: string,
    page: number = 1,
    limit: number = 20
  ): Observable<{ assets: any[]; totalAssets: number; page: number; limit: number; nextPage?: number }> {
    const storedId = localStorage.getItem('ss_SelectedStoreId');
    let id_loja = storedId || '';
    if (!id_loja) {
      const storeRaw = localStorage.getItem('store');
    
      if (storeRaw) {
        try {
          const storeObj = JSON.parse(storeRaw);
    
          if (storeObj?.SelectedStoreId) {
            id_loja = String(storeObj.SelectedStoreId);
          }
    
        } catch (e) {
          console.warn('Erro ao parsear localStorage.store', e);
        }
      }
    }

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/public/admin/store/${id_loja}/videoshopping/asset_public`;

    const params: any = {
      handle,
      source_id,
      page: String(page),
      limit: String(limit)
    };

    // Rota pública — sem Sanctum e sem withCredentials para funcionar de qualquer origem (Nuvemshop, Shopify, etc.)
    const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token') || '';
    const headersObj: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) headersObj['Authorization'] = `Bearer ${token}`;

    return this.http.get<{ assets: any[]; totalAssets: number; page: number; limit: number; nextPage?: number }>(
      url,
      { headers: new HttpHeaders(headersObj), params }
    ).pipe(
      catchError(err => throwError(() => err))
    );
  }


  listSlickMaps(uniq_id: string): Observable<SlickMaps[]> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/videoshopping/asset/${uniq_id}/maps`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<SlickMaps[]>(url, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }


  create_pixel(data: any): Observable<Produto> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/pixel`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() => from(this.authHeaderService.getHttpOptions())),
      switchMap(httpOptions =>
        this.http.post<Produto>(url, data, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }


  update_pixel(data: any, pixel_id: number): Observable<Produto> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/pixel/${pixel_id}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.patch<Produto>(url, data, httpOptions)
          )
        )
      ),
      catchError(error => throwError(() => error))
    );
  }

  listPixelLazy(uuid: string, page: number, size: number, searchTerm = ''): Observable<any> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/asset/${uuid}/pixel`;

    const params = new HttpParams()
      .set('page', (page === 0 ? 1 : page).toString())
      .set('limit', size.toString());

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions => {
        const options = { ...httpOptions, params };
        return this.http.get<any>(url, options);
      })
    );
  }

  // Cache-first com ETag.
  listPixelLazyRevalidated(uuid: string, page: number, size: number, searchTerm = ''): RevalidatedResource<any> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/asset/${uuid}/pixel`;
    const normalizedPage = page === 0 ? 1 : page;

    const params = new HttpParams()
      .set('page', normalizedPage.toString())
      .set('limit', size.toString());

    const cacheKey = `pixels:store:${id_loja}:asset:${uuid}:page:${normalizedPage}:size:${size}:search:${searchTerm}`;

    return this.revalidatedHttp.getSignal<any>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions(),
      { params }
    );
  }


  list_pixel(): Observable<any> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    if (!id_loja) {
      const store = localStorage.getItem("store");
      if (store) {
        try {
          const parsedStore = JSON.parse(store);
          id_loja = parsedStore?.SelectedStoreId || '';
        } catch (error) {
          console.error('Erro ao parsear store do localStorage:', error);
        }
      }
    }

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/public/admin/store/${id_loja}/pixel_public`;
    console.log('[pixel_public] liveshop.service — id_loja:', id_loja, '| ss_SelectedStoreId:', localStorage.getItem('ss_SelectedStoreId'), '| SelectedStoreId:', localStorage.getItem('SelectedStoreId'));

    return from(this.authHeaderService.getPublicHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<any>(url, httpOptions)
      )
    );
  }


  detail_pixel(pixel_id: string): Observable<Produto> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/pixel/${pixel_id}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<Produto>(url, httpOptions)
      )
    );
  }

  // Cache-first com ETag.
  detailPixelRevalidated(pixel_id: string): RevalidatedResource<Produto> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/pixel/${pixel_id}`;
    const cacheKey = `pixel_detail:store:${id_loja}:id:${pixel_id}`;

    return this.revalidatedHttp.getSignal<Produto>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }


  deletar_pixel(pixel_id: string): Observable<Produto> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/pixel/${pixel_id}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.delete<Produto>(url, httpOptions)
          )
        )
      ),
      catchError(error => throwError(() => error))
    );
  }


  sendHook(uid: string): Observable<any> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/disableLive`;
    const body = { uid };

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<any>(url, body, httpOptions)
          )
        )
      ),
      catchError(error => throwError(() => error))
    );
  }

  enableLive(liveShopId: string): Observable<any> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/liveshopping/enableLive/${liveShopId}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<any>(url, httpOptions)
      )
    );
  }

  getLive(liveShopId: string): Observable<any> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const url = `${this.baseurl}/admin/store/${id_loja}/liveshopping/details_live/${liveShopId}`;
    if (environment.production) {
      return this.http.get<any>(url, this.httpOptions);
    } else {
      return this.http.get<any>(url, this.httpOptions);
    }
  }
  getLiveData(liveShopId: string): Observable<any> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const url = `${this.baseurl}/public/admin/store/${id_loja}/liveshopping/detail/${liveShopId}`;
    console.log('Chamou detalhar dados de transmissão');
    console.log(url);
    if (environment.production) {
      return this.http.get<any>(url, this.httpOptions);
    } else {
      return this.http.get<any>(url, this.httpOptions);
    }
  }
  getLiveDetails(liveShopId: string): Observable<any> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const url = `${this.baseurl}/admin/store/${id_loja}/liveshopping/details_live_mux/${liveShopId}`;

    if (environment.production) {
      return this.http.get<any>(url, this.httpOptions);
    } else {
      return this.http.get<any>(url, this.httpOptions);
    }
  }
  getLiveTert(liveShopId: string): Observable<any> {
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const url = `${this.baseurl}/admin/store/${id_loja}/liveshopping/tert/${liveShopId}`;

    if (environment.production) {
      return this.http.get<any>(url, this.httpOptions);
    } else {
      return this.http.get<any>(url, this.httpOptions);
    }
  }

  generatePix(): Observable<any> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const user_id = localStorage.getItem("user_id") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/gerarPix/${user_id}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<any>(url, null, httpOptions)
          )
        )
      ),
      retry(1),
      catchError(this.handleError)
    );
  }

  liveSimulator(duration_time: number, bitrate_fps: number, viewers: string, average_view_time: number): Observable<any> {
    var body = {
      duration_time: duration_time,
      bitrate_fps: bitrate_fps,
      viewers: viewers,
      average_view_time: average_view_time
    }
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    console.log(body);

    if (environment.production) {
      const url = `${environment.serverUrl}/admin/store/${id_loja}/liveshopping/simulate/live`;
      return this.http.post<any>(url, body, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        );
    } else {
      const url = `${environment.serverUrl}/admin/store/${id_loja}/liveshopping/simulate/live`;
      return this.http.post<any>(url, body, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        );
    }
  }


  //////////////////////////
  getGa4Metrics(
    dateFrom?: Date,
    dateTo?: Date,
    propertyIds?: string[]
  ): Observable<Ga4MetricsResponse> {
    const id_loja = localStorage.getItem('ss_SelectedStoreId') || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/ga4_metrics`;

    // monta params
    let params = new HttpParams();

    if (dateFrom && dateTo) {
      const start = formatDate(dateFrom, 'yyyy-MM-dd', 'en');
      const end = formatDate(dateTo, 'yyyy-MM-dd', 'en');
      params = params.set('startDate', start).set('endDate', end);
    }

    if (propertyIds && propertyIds.length) {
      // backend aceita CSV
      params = params.set('properties', propertyIds.join(','));
    }

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<Ga4MetricsResponse>(url, { ...httpOptions, params })
      ),
      catchError(err => throwError(() => err))
    );
  }

  // Mesmo padrão cache-first do getTopSlicksRevalidated.
  getGa4MetricsRevalidated(
    dateFrom?: Date,
    dateTo?: Date,
    propertyIds?: string[]
  ): RevalidatedResource<Ga4MetricsResponse> {
    const id_loja = localStorage.getItem('ss_SelectedStoreId') || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/ga4_metrics`;

    let params = new HttpParams();
    let start = '';
    let end = '';

    if (dateFrom && dateTo) {
      start = formatDate(dateFrom, 'yyyy-MM-dd', 'en');
      end = formatDate(dateTo, 'yyyy-MM-dd', 'en');
      params = params.set('startDate', start).set('endDate', end);
    }

    const propsKey = (propertyIds && propertyIds.length) ? propertyIds.slice().sort().join(',') : '';
    if (propsKey) {
      params = params.set('properties', propsKey);
    }

    const cacheKey = `ga4_metrics:store:${id_loja}:from:${start}:to:${end}:props:${propsKey}`;

    return this.revalidatedHttp.getSignal<Ga4MetricsResponse>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions(),
      { params }
    );
  }
  //////////////////////////

  private resolveStoreId(): string | null {
    let storeId = localStorage.getItem('ss_SelectedStoreId');

    if (!storeId) {
      const storeRaw = localStorage.getItem('store');
      if (storeRaw) {
        try {
          const parsed = JSON.parse(storeRaw);
          storeId = parsed?.SelectedStoreId ?? parsed?.store_id ?? parsed?.storeId ?? '';
        } catch (error) {
          console.warn('Não foi possível parsear store do localStorage', error);
        }
      }
    }

    if (storeId === undefined || storeId === null || storeId === '') {
      return null;
    }

    return String(storeId);
  }
}
